import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { LocationsRegisterComponent } from './containers/locations-register.component';
import { LocationsRegisterEffects } from './state/locations-register.effects';
import { locationsRegisterFeatureKey, locationsRegisterReducer } from './state/locations-register.reducer';
import { LocationsRegisterViewComponent } from './views/locations-register-view.component';

@NgModule({
   declarations: [LocationsRegisterComponent, LocationsRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      AddSpacesPipeModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      MatMenuModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      LocationModule,
      EffectsModule.forFeature([LocationsRegisterEffects]),
      StoreModule.forFeature(locationsRegisterFeatureKey, locationsRegisterReducer),
   ],
})
export class LocationsRegisterModule {}
